import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type CustomerPairingRatingDetail } from '../../../../../../src/types/CustomerPairingRatingDetail';

export async function postApiV2CustomersCustomerIdPairingRatings(
  customerId: number,
  requestBody: Omit<CustomerPairingRatingDetail, 'customer_id'>
) {
  return await send<CustomerPairingRatingDetail>({
    path: `/api/v2/customers/${customerId}/pairing_ratings/`,
    method: 'POST',
    body: requestBody,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
